// $FlowFixMe
import { format } from 'date-fns';


const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

const unlimitedCheck = (string) => string === '-1' ? 'UNLIMITED' : string;

const allValuesAreFalse = (addon) => Object.values(addon).every(
  (value) => value === false
);

const getSubscriptionInfoFromContract = (contract) => {
  const {
    ContractId,
    // $FlowFixMe
    Payload: { subscription, addons },
    EndDate
  } = contract;

  const name = ContractId ? capitalizeFirstLetter(ContractId.split('|')[0].toLowerCase()) : '';

  const tier = subscription.TIER ? capitalizeFirstLetter(subscription.TIER.toLowerCase()) : '';

  const amendments = subscription && subscription.PROJECT_AMENDMENTS ?
  subscription.PROJECT_AMENDMENTS :
  '';
  const sla = subscription && subscription.SLA ?
  subscription.SLA :
  '';

  let numberOfAddons = 0;
  if (addons) {
    Object.values(addons).forEach((addon) => {
      // Either it's an object, in which case we need to check inside it for any true values,
      // or it's not, in which case we don't and can just use it's truthyness
      // I.e. if an SRT_CAPTIONS object has any true value against any language, we count
      // SRT_CAPTIONS as an addon
      if (addon && (
      typeof addon !== 'object' ||
      typeof addon === 'object' && !allValuesAreFalse(addon)))
      {
        numberOfAddons += 1;
      }
    });
  }

  const addonsText = numberOfAddons ? `\u00A0\u00A0\u00A0\u00A0${unlimitedCheck(numberOfAddons)} incl. Add-ons` : '';

  const endDate = EndDate ? format(new Date(EndDate), 'd LLL yyyy') : '-';

  let info = '';
  if (name === 'Pro') {
    info = `${amendments ? `${unlimitedCheck(amendments.toString())} Amendments` : ''}` +
    `${amendments && sla ? '\u00A0\u00A0\u00A0\u00A0' : ''}` +
    `${sla ? `${sla}hr SLA ` : ''}` +
    `${addonsText}`;
  }

  return {
    name,
    tier,
    info,
    endDate,
    key: `${name}-${tier}${info}`
  };
};

export default getSubscriptionInfoFromContract;